namespace RioERP.Products {
    export interface ProductPendrivesForm {
        ProductId: Serenity.LookupEditor;
        PenDriveTypeId: Serenity.LookupEditor;
        Quantity: Serenity.IntegerEditor;
    }

    export class ProductPendrivesForm extends Serenity.PrefixedContext {
        static formKey = 'Products.ProductPendrives';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductPendrivesForm.init)  {
                ProductPendrivesForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.IntegerEditor;

                Q.initFormType(ProductPendrivesForm, [
                    'ProductId', w0,
                    'PenDriveTypeId', w0,
                    'Quantity', w1
                ]);
            }
        }
    }
}
